import { RouteName } from "~/types/routes";

export default defineNuxtRouteMiddleware((to) => {
  if (useHasPageAccess(to.name as string)) {
    return true;
  }

  return navigateTo({ name: RouteName.unauthorized });
});
